<div class="footer row">
  <div class="col-12 col-sm-6">
    ©{{ thisYear }} TRAFFIC TECH Incorporated. All rights reserved.
  </div>
</div>
